import React, { useEffect, useState } from 'react';
import {defineBlock, smartProps} from "@smartfire/wordpress-react";

import apiFetch from '@wordpress/api-fetch';
import "slick-carousel/slick/slick.css";
import Tuile from "./realisation-tuile";

import style from "./block.module.scss";

function Block({offreId}){

    const [listPosts, setListsPost] = useState([]);

    useEffect(()=>{

        apiFetch( { path: `/wp/v2/realisation?_embeds&per_page=3&offre_id=`+offreId + '&lang=' + window.localStorage.i18nextLng} ).then( data => {
            setListsPost(data);
        });
    },[setListsPost, offreId]);

    if (!listPosts.length)
        return null

    return  <div className={style.block}>
        <div className={style.actuList}>
            <h2 className={style.titre}><span className={style.titreText}>Réalisations associées</span></h2>
            <div className={style.content}>
                {listPosts && listPosts.length > 0 && listPosts.map((post, index) => (
                    <div key={index} className={style.div}>
                        <Tuile image={post.featured_img_url} title={post.title.rendered} country={post.acf["real-offre"] && post.acf["real-offre"]["post_title"]} link={post.link} picto={post.picto_offer} />
                    </div>
                ))}
            </div>
        </div>
    </div>
}

export default defineBlock({
    Block,
    smartProps: {
        offreId: smartProps.string.withDefault(""),
    },
    setup: {
        title: "Liste des réalisations associées",
    }
})